import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function OfflinePage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Sin conexión</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            No hay conexión a internet. Revisa tu red e inténtalo de nuevo.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
